import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index'
import Error404 from "./views/Error404";
import TermsOfUse from "./views/TermsOfUse";
import PrivacyPolicy from "./views/PrivacyPolicy";
import Clients from "./views/admin/Clients";
import ClientPage from "./views/admin/ClientPage";
import Profile from "./views/admin/Profile";
import Notifications from "./views/admin/Notifications";
import EmailConfirm from "./views/EmailConfirm";
import ClientMails from "./views/ClientMails";
import ClientProfile from "./views/ClientProfile";
import ClientContacts from "./views/ClientContacts";
import store from '@/store';
import constants from '@/constants';
import PasswordRecovery from "./views/PasswordRecovery";
import PasswordRecoveryDenied from "./views/PasswordRecoveryDenied";
import MailCreate from "./views/MailCreate";
import SubscriptionConfirm from "./views/SubscriptionConfirm";
import RegistrationThanks from "@/views/RegistrationThanks";


Vue.use(Router);

const checkAuthAndRoles = async (to, from, next, roles) => {
    let auth = await store.dispatch('isAuthenticated');

    if (!auth) {
        let socialToken  = to.query.socialToken;
        if (!!socialToken) {
            await store.dispatch('setSocialToken', socialToken);
            let isAuthenticated = await store.dispatch('loadCurrentUserData');
            if (!isAuthenticated) {
                await store.dispatch('logout');
                sessionStorage.setItem(constants.SESSION_STORAGE_REDIRECT, to.path);
                next({name: 'Index'});
                return;
            }
        } else {
            sessionStorage.setItem(constants.SESSION_STORAGE_REDIRECT, to.path);
            next({name: 'Index'});
            return;
        }
    }

    if (roles && roles.length > 0) {
        const roleCode = store.getters.currentUser.role;
        let access = roles.indexOf(roleCode) != -1;

        if (!access) {
            if (from.params.code === '403')
                next(false);
            else
                next({name: 'Index'});
            return;
        }
    }

    if (to.name === 'MailCreate') {
        if (!store.getters.isPhoneFilled && !store.getters.isContactsFilled) {
            $('.window-wrapper.window-new-mail-not-filled').addClass('window-open');
            next(false);
            return;
        } else if (!store.getters.isPhoneFilled) {
            $('.window-wrapper.window-new-mail-no-phone').addClass('window-open');
            next(false);
            return;
        } else if (!store.getters.isContactsFilled) {
            $('.window-wrapper.window-new-mail-no-contacts').addClass('window-open');
            next(false);
            return;
        }

    }

    next();
};

const checkEmailConfirmLink = async (to, from, next) => {
    let success = await store.dispatch('confirmEmail', to.params.link);
    if (!success) {
        next({name: 'Error404'});
        return
    }
    next();
};

const checkPasswordRecoveryLink = async (to, from, next) => {
    let data = {
        token: to.params.token,
        id: to.query.i
    };
    let success = await store.dispatch('checkPasswordRecoveryLink', data);
    if (!success) {
        next({name: 'PasswordRecoveryDenied'});
        return;
    }
    next();
};


export default new Router({
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'Index',
            meta: {title: 'Your Last Word'},
            component: Index
        },

        {
            path: '/terms-of-use',
            name: 'TermsOfUse',
            component: TermsOfUse
        },
        {
            path: '/privacy-policy',
            name: 'PrivacyPolicy',
            component: PrivacyPolicy
        },
        {
            path: '/profile-admin',
            name: 'Profile',
            component: Profile,
            beforeEnter: (to, from, next) => {
                store.dispatch('updateNotificationsCount');
                checkAuthAndRoles(to, from, next, [constants.ROLE.ADMIN])
            }
        },
        {
            path: '/clients',
            name: 'Clients',
            component: Clients,
            beforeEnter: (to, from, next) => {
                store.dispatch('updateNotificationsCount');
                checkAuthAndRoles(to, from, next, [constants.ROLE.ADMIN])
            }
        },
        {
            path: '/client',
            name: 'ClientPage',
            component: ClientPage,
            beforeEnter: (to, from, next) => {
                store.dispatch('updateNotificationsCount');
                checkAuthAndRoles(to, from, next, [constants.ROLE.ADMIN])
            }
        },
        {
            path: '/notifications',
            name: 'Notifications',
            component: Notifications,
            beforeEnter: (to, from, next) => {
                store.dispatch('updateNotificationsCount');
                checkAuthAndRoles(to, from, next, [constants.ROLE.ADMIN])
            }
        },
        {
            path: '/profile',
            name: 'ClientProfile',
            component: ClientProfile,
            beforeEnter: (to, from, next) => {
                checkAuthAndRoles(to, from, next, [constants.ROLE.CLIENT])
            }
        },

        {
            path: '/contacts',
            name: 'ClientContacts',
            component: ClientContacts,
            beforeEnter: (to, from, next) => {
                checkAuthAndRoles(to, from, next, [constants.ROLE.CLIENT])
            }
        },

        {
            path: '/mails',
            name: 'ClientMails',
            component: ClientMails,
            beforeEnter: (to, from, next) => {
                checkAuthAndRoles(to, from, next, [constants.ROLE.CLIENT])
            }
        },

        {
            path: '/mail',
            name: 'MailCreate',
            component: MailCreate,
            beforeEnter: (to, from, next) => {
                checkAuthAndRoles(to, from, next, [constants.ROLE.CLIENT])
            }
        },

        {
            path: '/subscribe',
            name: 'SubscriptionConfirm',
            component: SubscriptionConfirm,
            beforeEnter: (to, from, next) => {
                checkAuthAndRoles(to, from, next, [constants.ROLE.CLIENT])
            }
        },

        {
            path: '/email-confirm/:link', props: true,
            name: 'EmailConfirm',
            component: EmailConfirm,
            beforeEnter: (to, from, next) => {
                checkEmailConfirmLink(to, from, next)
            }
        },

        {
            path: '/registration-thanks',
            name: 'RegistrationThanks',
            component: RegistrationThanks,
        },

        {
            path: '/password-recovery/:token', props: true,
            name: 'PasswordRecovery',
            component: PasswordRecovery,
            beforeEnter: (to, from, next) => {
                checkPasswordRecoveryLink(to, from, next)
            }
        },

        {
            path: '/password-recovery-denied',
            name: 'PasswordRecoveryDenied',
            component: PasswordRecoveryDenied
        },


        {
            path: '/404',
            component: Error404,
            name: 'Error404'
        },
        // Должно стоять последним
        {
            path: '/*',
            redirect: '/404'
        }
    ]
})


